export const IMAGES = {
  logo: "/bilder/logo-ringel.png",
  heroes: [
    {
      src: "/bilder/hero-1.jpg",
      kicker: "Fenster & Glasfassaden",
      title: ["Licht gibt", "Räumen ein", "Gesicht."],
      text: "Großformatige Fensterfronten mit schlanken Anthrazit-Profilen – geplant, geliefert und montiert von Ringel.",
    },
    {
      src: "/bilder/hero-team.jpg",
      kicker: "Montage mit System",
      title: ["Eingebaut.", "Abgedichtet.", "Übergeben."],
      text: "Unsere Monteure arbeiten nach RAL-Montagestandard – sauber, staubarm und termintreu.",
    },
    {
      src: "/bilder/hero-2.jpg",
      kicker: "Haustüren aus Aluminium",
      title: ["Der erste", "Eindruck", "zählt."],
      text: "Haustüren in Anthrazit mit hochwertigen Griffstangen – Sicherheit trifft auf Design.",
    },
    {
      src: "/bilder/hero-3.jpg",
      kicker: "Terrassendach & Wintergarten",
      title: ["Draußen", "sitzen –", "zu jeder Zeit."],
      text: "Terrassendächer und Wintergärten, die Ihre Terrasse zum zweiten Wohnzimmer machen.",
    },
  ],
  products: [
    { img: "/bilder/fenster.jpg", name: "Fenster", desc: "Kunststoff- & Alu-Fenster mit 3-fach-Verglasung" },
    { img: "/bilder/haustuer.jpg", name: "Haustüren", desc: "Aluminium-Haustüren mit Seitenteilen" },
    { img: "/bilder/rolllaeden.jpg", name: "Rollläden", desc: "Elektrisch, gedämmt, einbruchhemmend" },
    { img: "/bilder/sonnenschutz.jpg", name: "Sonnenschutz", desc: "Textilscreens, Markisen & Raffstores" },
    { img: "/bilder/insektenschutz.jpg", name: "Insektenschutz", desc: "Spannrahmen, Drehtüren & Schiebeanlagen" },
    { img: "/bilder/wintergarten.jpg", name: "Wintergarten", desc: "Ganzjährig nutzbare Glas-Anbauten" },
    { img: "/bilder/vordach.jpg", name: "Vordächer", desc: "Glasvordächer mit Anthrazit-Tragwerk" },
    { img: "/bilder/schiebetuer.jpg", name: "Schiebetüren", desc: "Hebe-Schiebe-Elemente bis 6 m Breite" },
    { img: "/bilder/garagentor.jpg", name: "Garagentore", desc: "Gedämmte Sektionaltore mit Antrieb" },
    { img: "/bilder/zaun.jpg", name: "Zäune", desc: "Alu-Lamellenzäune, Sichtschutz & Tore" },
    { img: "/bilder/pergola.jpg", name: "Pergolen", desc: "Alu-Lamellendächer für Terrasse & Garten" },
  ],
  references: [
    { img: "/bilder/ref-1.jpg", title: "Altbausanierung", place: "Bestand, denkmalgerecht", tags: ["Fenster", "Haustür"] },
    { img: "/bilder/ref-2.jpg", title: "Haustür mit Seitenteil", place: "Neubau Einfamilienhaus", tags: ["Aluminium", "Anthrazit"] },
    { img: "/bilder/ref-3.jpg", title: "Terrassendach & Markise", place: "Gartenseitiger Anbau", tags: ["Terrassendach", "Beschattung"] },
    { img: "/bilder/ref-4.jpg", title: "Wintergarten", place: "Ganzjahres-Wintergarten", tags: ["Glas", "Beschattung"] },
    { img: "/bilder/ref-5.jpg", title: "Elektrische Rollläden", place: "Neubau, Smart Home", tags: ["Rollladen", "Motorik"] },
    { img: "/bilder/ref-6.jpg", title: "Hebe-Schiebe-Tür", place: "Terrassenzugang 5,2 m", tags: ["Schiebetür", "3-fach-Glas"] },
  ],
  team: [
    { img: "/bilder/team-montage.jpg", label: "Einbau vor Ort" },
    { img: "/bilder/team-1.jpg", label: "Werkzeug & Detailarbeit" },
    { img: "/bilder/team-2.jpg", label: "Profil-Montage" },
    { img: "/bilder/team-3.jpg", label: "Aufmaß & Vermessung" },
  ],
};

export const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Konfigurator", href: "#konfigurator" },
  { label: "Referenzen", href: "#referenzen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Partner", href: "#partner" },
  { label: "Kontakt", href: "#kontakt" },
];

export const CONTACT = {
  phone: "0163 36 28 171",
  phoneRaw: "+491633628171",
  email: "bauelemente.ringel@gmail.com",
  address: "Kamen",
  hours: "Mo–Fr 7:00–17:00 · Sa n. Vereinbarung",
  owner: "Andreas Ringel",
  legalAddress: "Ostkamp 50 · 59174 Kamen",
};
